import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { Quote, Set_Quote } from '../interfaces/interfaces.index';
import { NewAdviser } from '../interfaces/new_adviser';
const URL = `${URL_SERVICIOS}Quote`;

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(public http: HttpClient) { }

  getCitas = (id: number) => this.http.get<Quote>(`${URL}/adviser/${id}`, HTTP_OPTIONS);

  getCitasDay = (id: number, data: Date) => this.http.get<Quote>(`${URL}/adviser/${id}/date/${data.toJSON()}`);

  agendarCita = (data: Set_Quote) => this.http.post(`${URL}`, JSON.stringify(data), HTTP_OPTIONS);
}
